
import "../SidebarItemNext/SidebarItemNext.st.css.js";
import "../Popover/Popover.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_SidebarSubMenuNext";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_SidebarSubMenuNext__root","subMenu":"wds_1_209_0_SidebarSubMenuNext__subMenu","subMenuItems":"wds_1_209_0_SidebarSubMenuNext__subMenuItems","chevronRight":"wds_1_209_0_SidebarSubMenuNext__chevronRight","navigationPopoverRoot":"wds_1_209_0_SidebarSubMenuNext__navigationPopoverRoot","navigationPopover":"wds_1_209_0_SidebarSubMenuNext__navigationPopover"};
export var keyframes = {"rotateChevronUp":"wds_1_209_0_SidebarSubMenuNext__rotateChevronUp","rotateChevronBack":"wds_1_209_0_SidebarSubMenuNext__rotateChevronBack","openItems":"wds_1_209_0_SidebarSubMenuNext__openItems","closeItems":"wds_1_209_0_SidebarSubMenuNext__closeItems"}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




